import { Group, Select, Badge, Text, Tooltip } from "@mantine/core";
import { IconActivity } from "@tabler/icons-react";
import { useAutoRefresh } from "../autoRefresh";

const OPTIONS = [
  { value: "0", label: "Off" },
  { value: "5000", label: "5 seconds" },
  { value: "15000", label: "15 seconds" },
  { value: "30000", label: "30 seconds" },
  { value: "60000", label: "1 minute" },
  { value: "300000", label: "5 minutes" },
];

// Toolbar control: pick a global auto-refresh interval. When non-zero, every
// widget/page that watches the refreshKey re-fetches on each tick.
export default function RefreshControl() {
  const { intervalMs, setIntervalMs, tick } = useAutoRefresh();
  return (
    <Group gap="xs" wrap="nowrap">
      <Tooltip label="Global auto-refresh interval — applies to every widget that subscribes." withArrow multiline w={260}>
        <Group gap={6} wrap="nowrap" style={{ cursor: "help" }}>
          <IconActivity size={14} />
          <Text size="sm" c="dimmed">
            Auto-refresh
          </Text>
        </Group>
      </Tooltip>
      <Select
        size="xs"
        w={130}
        allowDeselect={false}
        value={String(intervalMs)}
        data={OPTIONS}
        onChange={(v) => setIntervalMs(parseInt(v ?? "0", 10))}
      />
      {intervalMs > 0 ? (
        <Badge color="brand" variant="light" size="sm">
          tick #{tick}
        </Badge>
      ) : null}
    </Group>
  );
}
